const messages = {
  buttons: {
    productBrochures: "Découvrir",
  },
  index: {
    title: "INFORMATION PRODUIT",
    description:
      "Bienvenue dans la zone d'information consacrée aux produits Bridgestone et Firestone. Vous trouverez ici les brochures actuelles et des documents complémentaires.",
    categories: {
      productBrochures: {
        title: "Brochures sur les produits",
        description:
          "Brochures produits Bridgestone et Firestone actuelles à télécharger",
      },
      bDrive: {
        title: "Images de produits",
        description:
          "Vous trouverez les images actuelles à télécharger sur notre portail B-DRIVE.",
        button: "VERS B-DRIVE",
      },
    
      kickback: {
        description: "Les entreprises participantes reçoivent des crédits sous forme de remises basées sur les chiffres de ventes transmis.",
      },
    },
  },
};

export default {
  messages,
};
